import {basePath} from './basePath';
export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://music_adjudicator.localhost:81/api/' : basePath+'api/' // Shahid env
// export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://music_adjudicator.test/api/' : basePath+'api/' // Numan env


// WEBPACK FOOTER //
// ./src/helper/ApiCall.jsx